export default __webpack_public_path__ + "static/media/payment-add-payout.8bfac7e8.svg";